import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useReducedMotion } from "framer-motion";
import { BgVideo } from "./BgVideo";
import { img } from "@/lib/media";
import { useLang } from "@/lib/i18n";

export const Hero = ({ posterFile }) => {
  const reduce = useReducedMotion();
  const { t, lang } = useLang();
  const layer = useRef(null);
  const poster = img(posterFile, 1600);
  useEffect(() => {
    if (reduce) return undefined;
    let raf = 0;
    const onScroll = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        if (layer.current) layer.current.style.transform = `translate3d(0, ${Math.min(window.scrollY, 900) * 0.18}px, 0)`;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => { window.removeEventListener("scroll", onScroll); cancelAnimationFrame(raf); };
  }, [reduce]);
  return (
    <section className="hero" data-testid="hero-section">
      <div className="hero-media" ref={layer} style={{ backgroundImage: `url(${poster})` }}>
        <BgVideo src="/videos/hero.mp4" poster={poster} testId="hero-video" />
      </div>
      <div className="wrap" key={lang}>
        <h1 data-testid="hero-heading">
          <span className="ln"><span style={{ animationDelay: "0.15s" }}>{t.hero.l1}</span></span>{" "}
          <span className="ln"><span style={{ animationDelay: "0.35s" }}>{t.hero.l2}</span></span>
        </h1>
        <p className="lede fade-in" style={{ animationDelay: "0.6s" }}>{t.hero.lede}</p>
        <div className="btns fade-in" style={{ animationDelay: "0.75s" }}>
          <Link className="btn" to="/gallery" data-testid="hero-view-gallery-btn">{t.hero.work}</Link>
          <a className="btn ghost" href="#inquire" data-testid="hero-inquiry-btn">{t.hero.inquiry}</a>
        </div>
      </div>
    </section>
  );
};
